import { serviceMaker, methods, api } from "../index.js";

export const fetchDiscountList = () =>
  serviceMaker(`/discounts`, methods.GET, api.NGB);

export const createDiscount = (data) =>
  serviceMaker(`/discounts`, methods.POST, api.NGB, data);
export const updateDiscount = (data) =>
  serviceMaker(`/discounts/${data.id}`, methods.PUT, api.NGB, data.data);

export const createDiscountTrigger = (data) =>
  serviceMaker(`/discounttrigger`, methods.POST, api.NGB, data);
export const updateDiscountTrigger = (data) =>
  serviceMaker(`/discounttrigger/${data.id}`, methods.PUT, api.NGB, data.data);
export const updateDiscountTriggerCondition = (data) =>
  serviceMaker(
    `/discounttriggercondition/${data.id}`,
    methods.PUT,
    api.NGB,
    data.data
  );
export const createDiscountRule = (data) =>
  serviceMaker(`/discountrule`, methods.POST, api.NGB, data);
export const deleteDiscountRuleApi = (id) =>
  serviceMaker(`discountrule/${id}`, methods.DELETE, api.NGB);
export const updateDiscountRule = (data) =>
  serviceMaker(`/discountrule/${data.id}`, methods.PUT, api.NGB, data.data);
export const createDiscountRate = (data) =>
  serviceMaker(`/discountrate`, methods.POST, api.NGB, data);

export const discountTriggerData = (id) =>
  serviceMaker(`/discounttrigger/${id}`, methods.GET, api.NGB);
export const deleteDiscountTrigger = (id) =>
  serviceMaker(`/discounttrigger/${id}`, methods.DELETE, api.NGB);
export const getDiscountRate = (id) =>
  serviceMaker(`/discountrate/discount/${id}`, methods.GET, api.NGB);
export const getDiscountRule = (id) =>
  serviceMaker(`/discountrule/${id}`, methods.GET, api.NGB);
export const deleteDiscountRate = (id) =>
  serviceMaker(`/discountrate/${id}`, methods.DELETE, api.NGB);
export const deleteDiscountRule = (id) =>
  serviceMaker(`/discountrule/${id}`, methods.DELETE, api.NGB);
export const createTriggerCondition = (data) =>
  serviceMaker(`/discounttriggercondition`, methods.POST, api.NGB, data);
export const getTriggerConditionData = (id) =>
  serviceMaker(`/discounttriggercondition/${id}`, methods.GET, api.NGB);
export const deleteTriggerConditionData = (id) =>
  serviceMaker(`/discounttriggercondition/${id}`, methods.DELETE, api.NGB);
export const getReportsTemplateData = () =>
  serviceMaker(`/reports/template`, methods.GET, api.NGB);
export const getExternalPromotions = () =>
  serviceMaker(`/extrnal/promotions`, methods.GET, api.NGB);
export const fetchPromotionList = (id) =>
  serviceMaker(`/discounts/promosbypackid/${id}`, methods.GET, api.NGB);

export const getTicketSubCategory = (parameterName) =>
  serviceMaker(
    `/runreports/${parameterName}?parameterType=true`,
    methods.GET,
    api.NGB
  );
export const ruleEntityListApi = () =>
  serviceMaker(`/entites/rule`, methods.GET, api.NGB);
export const ruleValueOptionsApi = (templatename) =>
  serviceMaker(
    `/templatequery/rule?templatename=${templatename}`,
    methods.GET,
    api.NGB
  );
export const triggerEntityListApi = () =>
  serviceMaker(`/entites/trigger`, methods.GET, api.NGB);
export const TriggerValueOptionsApi = (templatename) =>
  serviceMaker(
    `/templatequery/Trigger?templatename=${templatename}`,
    methods.GET,
    api.NGB
  );

  export const getDayOfWeek = () =>
  serviceMaker(`/codes/166/codevalues`, methods.GET, api.NGB);
  export const getWeek = () =>
  serviceMaker(`/codes/168/codevalues`, methods.GET, api.NGB);
  export const getCodeValuesById = (id) =>
  serviceMaker(`/codes/${id}/codevalues`, methods.GET, api.NGB);
